// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__qZrum","icon":"SocialMedia_icon__jLxzF"};